import React, { type ReactNode, type Ref } from 'react';
import styled from 'styled-components';
import { clsx } from 'clsx';
import Link from 'components/common/Link';
import Button from 'components/common/Button';

const StyledLink = styled(Link)<{ style?: React.CSSProperties }>`
  display: flex;
  align-items: center;
  width: 100%;
  height: inherit;
  padding: 0 8px;
  line-height: 1;
  color: ${({ theme }) => theme.colors.text.primary};
`;

type ButtonLinkProps = {
  children?: ReactNode;
  to: string;
  left?: boolean;
  transparent?: boolean;
  className?: string;
  variant?: 'contained' | 'outlined' | 'accented' | 'text';
  color?: string;
  'aria-label'?: string;
  'data-test-id'?: string;
  ref?: Ref<HTMLButtonElement>;
};

// TODO: make justify content properly
const ButtonLink = ({
  children,
  to,
  left = false,
  transparent,
  ['aria-label']: ariaLabel,
  className,
  ref,
  ...props
}: ButtonLinkProps) => (
  <Button {...props} ref={ref} className={clsx(className, 'p-0')}>
    <StyledLink
      to={to || '#'}
      aria-label={ariaLabel}
      style={{
        justifyContent: left ? 'flex-start' : 'center',
      }}
    >
      {children}
    </StyledLink>
  </Button>
);

export default ButtonLink;
